'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isNumber = subject => typeof subject === 'number';

const isArray = Array.isArray;

// Dynamic Weighted Moving Average

// @param {Number|Array.<Number>} alpha
var dma = ((data, alpha, noHead) => {

  const length = data.length;

  if (alpha > 1) {
    return Array(length);
  }

  if (alpha === 1) {
    return data.slice();
  }

  const noArrayWeight = !isArray(alpha);
  const ret = [];

  let datum;

  // period `i`
  let i = 0;

  // `s` is the value of the DWMA at any time period `i`
  let s = 0;

  // Handles head
  for (; i < length; i++) {
    datum = data[i];

    if (isNumber(datum) && (noArrayWeight || isNumber(datum))) {

      ret[i] = noHead ? 0 : datum;

      s = datum;
      i++;

      break;
    }
  }

  // Dynamic weights: an array of weights
  // Ref:
  // https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
  // with a dynamic alpha
  if (!noArrayWeight) {
    for (; i < length; i++) {
      datum = data[i];

      isNumber(datum) && isNumber(alpha[i]) ? s = ret[i] = alpha[i] * datum + (1 - alpha[i]) * s : ret[i] = ret[i - 1];
    }

    return ret;
  }

  const o = 1 - alpha;

  // Fixed alpha
  for (; i < length; i++) {
    datum = data[i];

    isNumber(datum) ? s = ret[i] = alpha * datum + o * s : ret[i] = ret[i - 1];
  }

  return ret;
});

// Smoothed moving average

var sma = ((data, size, times = 1) => dma(data, times / size, 1));

// Exponential moving average with 86% total weight

var ema = ((data, size) => dma(data, 2 / (size + 1)));

// simple moving average

var ma = ((data, size) => {
  const length = data.length;

  if (!size) {
    return data.reduce((a, b) => a + b) / length;
  }

  if (size <= 1) {
    return data.slice();
  }

  if (size > length) {
    return Array(length);
  }

  const prepare = size - 1;
  const ret = [];
  let sum = 0;
  let i = 0;
  let counter = 0;
  let datum;

  for (; i < length && counter < prepare; i++) {
    datum = data[i];

    if (isNumber(datum)) {
      sum += datum;
      counter++;
    }
  }

  for (; i < length; i++) {
    datum = data[i];

    if (isNumber(datum)) {
      sum += datum;
    }

    if (isNumber(data[i - size])) {
      sum -= data[i - size];
    }

    ret[i] = sum / size;
  }

  return ret;
});

// Weighted moving average

var wma = ((data, size) => {
  const length = data.length;

  if (size <= 1) {
    return data.slice();
  }

  if (size > length) {
    return Array(length);
  }

  const ret = [];
  const denominator = size * (size + 1) / 2;
  const prepare = size - 1;
  let sum = 0;
  let numerator = 0;
  let datum = 0;
  let i = 0;
  let real = -1;

  for (; i < prepare; i++) {
    datum = data[i];

    if (isNumber(datum)) {
      sum += datum;
      numerator += (i + 1) * datum;
    }
  }

  for (; i < length; i++, real++) {
    datum = data[i];

    if (isNumber(datum)) {
      sum += datum;
      numerator += size * datum;
    }

    if (real >= 0 && isNumber(data[real])) {
      sum -= data[real];
    }

    ret[i] = numerator / denominator;
    numerator -= sum;
  }

  return ret;
});

exports.dma = dma;
exports.sma = sma;
exports.ema = ema;
exports.ma = ma;
exports.wma = wma;



//////////////////
// WEBPACK FOOTER
// ./~/moving-averages/lib/index.js
// module id = 1569
// module chunks = 0